// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-shell {
  min-height: 100vh;
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  background: #edf2f2;
}

.brand-pane {
  display: flex;
  flex-direction: column;
  /* padding: 48px 86px; */
  justify-content: center;
  align-items: center;
  background: #eef3f3;
}

.brand-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-right: 371px;
  margin-bottom: 11px;
}

.brand-logo {
  width: 44px;
  height: 44px;
  object-fit: contain;
}

.brand-name {
  font-weight: 700;
  font-size: 20px;
  color: #0b3a42;
}

.hero-title {
  font-size: 36px;
  line-height: 1.2;
  font-weight: 700;
  color: #0b3a42;
  margin: 16px 0 8px;
}

.hero-subtitle {
  color: #3b5860;
  margin: 0 0 28px;
  margin-right: 210px;
}

.hero-illustration {
  margin-top: 24px;
  width: 100%;
  max-width: 520px;
  aspect-ratio: 4/3;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: left bottom;
  opacity: 0.9;
  margin-left: 100px;
}

.form-pane {
  display: flex;
  align-items: center;
  justify-content: center;
  /* padding: 48px 40px; */
  align-items: center;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(8px);
}

.form-card {
  width: 100%;
  max-width: 520px;
  border-radius: 14px;
  padding: 28px 28px 32px;
  background: transparent;
  box-shadow: none;
}

.form-title {
  font-size: 28px;
  font-weight: 700;
  color: #0b3a42;
  margin: 4px 0 20px;
}

.field .MuiOutlinedInput-root,
.field .MuiTextField-root .MuiOutlinedInput-root {
  background-color: #ffffff;
  border-radius: 10px;
}

.login-checkbox {
  color: #ffffff !important;
}
.login-checkbox.Mui-checked {
  color: #ffffff !important;
}

.helper {
  min-height: 18px;
  margin-top: 6px;
}

.error {
  font-size: 13px;
  color: #b3261e;
}

.global-error {
  margin: 4px 0 8px;
}

.options-row {
  margin-top: 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.forgot-link {
  font-size: 14px;
  color: #3b5860;
}

.login-cta {
  width: 100%;
  margin-top: 16px !important;
  padding: 12px 16px !important;
  border-radius: 10px !important;
  background: #3f6675 !important;
  text-transform: none !important;
  font-weight: 600 !important;
  color: #ffffff;
}

@media (max-width: 980px) {
  .login-shell {
    grid-template-columns: 1fr;
  }
  .brand-pane {
    padding-bottom: 0;
  }
  .form-pane {
    padding-top: 16px;
  }
}

.sso-divider {
  display: flex;
  align-items: center;
  text-align: center;
  margin: 24px 0;
  color: #64748b;
  font-size: 14px;
}

.sso-divider::before,
.sso-divider::after {
  content: "";
  flex: 1 1;
  border-bottom: 1px solid #e2e8f0;
}

.sso-divider:not(:empty)::before {
  margin-right: 0.5em;
}

.sso-divider:not(:empty)::after {
  margin-left: 0.5em;
}

.sso-buttons {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.sso-button {
  width: 100%;
  padding: 10px 16px !important;
  border-radius: 10px !important;
  text-transform: none !important;
  font-weight: 500 !important;
  border: 1px solid #e2e8f0 !important;
  background: #ffffff !important;
  color: #1e293b !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  gap: 12px !important;
}

.sso-button img {
  width: 20px;
  height: 20px;
}

.sso-button:hover {
  background: #f8fafc !important;
  border-color: #cbd5e1 !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/LoginPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,4BAA4B;EAC5B,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,mBAAmB;EACnB,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,6BAA6B;EAC7B,8BAA8B;EAC9B,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,SAAO;EACP,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,6BAA6B;EAC7B,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;EAC3B,oCAAoC;EACpC,8BAA8B;EAC9B,yBAAyB;EACzB,wBAAwB;EACxB,kCAAkC;EAClC,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC","sourcesContent":[".login-shell {\n  min-height: 100vh;\n  display: grid;\n  grid-template-columns: 1.2fr 1fr;\n  background: #edf2f2;\n}\n\n.brand-pane {\n  display: flex;\n  flex-direction: column;\n  /* padding: 48px 86px; */\n  justify-content: center;\n  align-items: center;\n  background: #eef3f3;\n}\n\n.brand-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-right: 371px;\n  margin-bottom: 11px;\n}\n\n.brand-logo {\n  width: 44px;\n  height: 44px;\n  object-fit: contain;\n}\n\n.brand-name {\n  font-weight: 700;\n  font-size: 20px;\n  color: #0b3a42;\n}\n\n.hero-title {\n  font-size: 36px;\n  line-height: 1.2;\n  font-weight: 700;\n  color: #0b3a42;\n  margin: 16px 0 8px;\n}\n\n.hero-subtitle {\n  color: #3b5860;\n  margin: 0 0 28px;\n  margin-right: 210px;\n}\n\n.hero-illustration {\n  margin-top: 24px;\n  width: 100%;\n  max-width: 520px;\n  aspect-ratio: 4/3;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: left bottom;\n  opacity: 0.9;\n  margin-left: 100px;\n}\n\n.form-pane {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  /* padding: 48px 40px; */\n  align-items: center;\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(8px);\n}\n\n.form-card {\n  width: 100%;\n  max-width: 520px;\n  border-radius: 14px;\n  padding: 28px 28px 32px;\n  background: transparent;\n  box-shadow: none;\n}\n\n.form-title {\n  font-size: 28px;\n  font-weight: 700;\n  color: #0b3a42;\n  margin: 4px 0 20px;\n}\n\n.field .MuiOutlinedInput-root,\n.field .MuiTextField-root .MuiOutlinedInput-root {\n  background-color: #ffffff;\n  border-radius: 10px;\n}\n\n.login-checkbox {\n  color: #ffffff !important;\n}\n.login-checkbox.Mui-checked {\n  color: #ffffff !important;\n}\n\n.helper {\n  min-height: 18px;\n  margin-top: 6px;\n}\n\n.error {\n  font-size: 13px;\n  color: #b3261e;\n}\n\n.global-error {\n  margin: 4px 0 8px;\n}\n\n.options-row {\n  margin-top: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.forgot-link {\n  font-size: 14px;\n  color: #3b5860;\n}\n\n.login-cta {\n  width: 100%;\n  margin-top: 16px !important;\n  padding: 12px 16px !important;\n  border-radius: 10px !important;\n  background: #3f6675 !important;\n  text-transform: none !important;\n  font-weight: 600 !important;\n  color: #ffffff;\n}\n\n@media (max-width: 980px) {\n  .login-shell {\n    grid-template-columns: 1fr;\n  }\n  .brand-pane {\n    padding-bottom: 0;\n  }\n  .form-pane {\n    padding-top: 16px;\n  }\n}\n\n.sso-divider {\n  display: flex;\n  align-items: center;\n  text-align: center;\n  margin: 24px 0;\n  color: #64748b;\n  font-size: 14px;\n}\n\n.sso-divider::before,\n.sso-divider::after {\n  content: \"\";\n  flex: 1;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.sso-divider:not(:empty)::before {\n  margin-right: 0.5em;\n}\n\n.sso-divider:not(:empty)::after {\n  margin-left: 0.5em;\n}\n\n.sso-buttons {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.sso-button {\n  width: 100%;\n  padding: 10px 16px !important;\n  border-radius: 10px !important;\n  text-transform: none !important;\n  font-weight: 500 !important;\n  border: 1px solid #e2e8f0 !important;\n  background: #ffffff !important;\n  color: #1e293b !important;\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n  gap: 12px !important;\n}\n\n.sso-button img {\n  width: 20px;\n  height: 20px;\n}\n\n.sso-button:hover {\n  background: #f8fafc !important;\n  border-color: #cbd5e1 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
